import { useSelector } from 'react-redux';
import i18n from 'src/utils/translate';

import styled from 'styled-components';
import Link from 'next/link';
import { State } from 'src/types';

const navItems = [
  {
    text: 'News Feed',
    tabText: 'News Feed',
    href: '/',
    key: 'newsfeed',
  },
  {
    text: 'Explore',
    tabText: 'Explore',
    href: '/explore',
    key: 'explore',
  },
  {
    text: 'Saved posts',
    tabText: 'Saved',
    href: '/followed',
    key: 'followed',
  },
];

const Nav = styled.nav`
  border: 1px solid ${({theme}) => theme.colorGreyLight};
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    @media (${({theme}) => theme.underScreenSmall}) {
      display: flex;
      border-top: 1px solid ${({theme}) => theme.colorGreyLight};
    }
  }
`;

const Item = styled.li`
  border-top: 1px solid ${({theme}) => theme.colorGreyLight};
  a {
    display: block;
    padding: 8px 10px;
    border-left: 3px solid transparent;
    color: ${({theme}) => theme.colorBlack};
    font-size: ${({theme}) => theme.fontSizeS};
    line-height: ${({theme}) => theme.fontLineHeightSWide};
    :hover {
      border-color: ${({theme}) => theme.colorGreyLight};
    }
    &.isActive {
      border-color: ${({theme}) => theme.colorGreen};
      font-weight: 600;
    }
  }
  @media (${({theme}) => theme.underScreenSmall}) {
    border-top: none;
    a {
      border-left: none;
      border-bottom: 3px solid transparent;
      padding: 6px 8px;
    }
  }
`;

const UserCard = styled.div`
  display: flex;
  padding: 15px 15px 30px;
  img {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    margin-right: 10px;
  }
`;
const User = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;
const Name = styled.div`
  font-size: 20px;
  font-weight: 600;
`;

const NavItem = ({item}: {item: any}) => (
  <Item>
    <a className={item.key === 'explore' ? 'isActive' : ''} href={item.href}>
      {i18n.t(item.text)}
    </a>
  </Item>
);

const HomeNav = () => {
  const currentUser = useSelector(({context}: State) => context?.currentUser);

  if (!currentUser) return null;

  return (
    <Nav>
      <UserCard>
        <img alt={currentUser.username + ' profile image'} src={currentUser.avatarImageUrl} />
        <User>
          <Name>{currentUser.username}</Name>
          <Link href="/profile/edit">
            <a>{i18n.t('Update profile')}</a>
          </Link>
        </User>
      </UserCard>
      <ul>
        {navItems.map(item => <NavItem item={item} key={item.key}/>)}
      </ul>
    </Nav>
  );
};

export default HomeNav;
